var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-container',{attrs:{"buttonLabel":"close"}},[_c('template',{slot:"header"},[_vm._v("\n    "+_vm._s(_vm.$l['message'])+"\n  ")]),_c('div',{staticClass:"message"},[_vm._v("\n    "+_vm._s(_vm.message.get('content'))+"\n  ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }